/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Role_To_All_BuildingsInputs */



/**
* | output |
* | --- |
* | "Apply a role to all buildings" |
*
* @param {Apply_Role_To_All_BuildingsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const apply_role_to_all_buildings = /** @type {((inputs?: Apply_Role_To_All_BuildingsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Role_To_All_BuildingsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Apply a role to all buildings")
	return /** @type {LocalizedString} */ ("Appliquer un rôle sur tous les bâtiments")
});